import JoinTeam from "./button/JoinTeam";
import { useEffect } from "react";
import { Element } from "react-scroll";

export default function Team() {
  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;

      const teamJoin = document.getElementById("team_join");

      if (teamJoin.getBoundingClientRect().top < viewportHeight) {
        teamJoin.classList.add("animate-fadeInUpScroll");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="flex flex-col items-center justify-center mx-auto px-4">
      <Element name="team_join" id="team_join" className="mt-10 text-center">
        <h3 className="font-bold text-white text-3xl">
          Join us in shifting the world of entertainment
        </h3>
        <p className="text-slate-500 mt-5 pb-2">We are hiring!</p>
        <JoinTeam />
      </Element>
    </section>
  );
}
